// extracted by mini-css-extract-plugin
export default {"link":"contactUs_link__6YyH5","pagination":"contactUs_pagination__4wv8j","container":"contactUs_container__5QAXt","wrapper":"contactUs_wrapper__htRh1"};